const DIVISION_GROUP_TYPES = new Set(["division", "ungrouped"]);

export const SHIFT_TIMER_RESPONSE_SHAPE = Object.freeze({
    NORMAL: "normal",
    GROUP_BY_DIVISION: "group_by_division",
});

export function resolveShiftTimerResponseArray(payload) {
    if (payload == null) {
        return [];
    }
    if (Array.isArray(payload)) {
        return payload;
    }
    if (typeof payload === "object" && Array.isArray(payload.workline)) {
        return payload.workline;
    }
    return [];
}

function isShiftTimerDivisionGroupEntry(item) {
    return (
        typeof item === "object" &&
        item != null &&
        DIVISION_GROUP_TYPES.has(item.group_type) &&
        (item.head != null || Array.isArray(item.members))
    );
}

export function getShiftTimerResponseShape(payload) {
    const arr = resolveShiftTimerResponseArray(payload);
    if (arr.length > 0 && arr.some(isShiftTimerDivisionGroupEntry)) {
        return SHIFT_TIMER_RESPONSE_SHAPE.GROUP_BY_DIVISION;
    }
    return SHIFT_TIMER_RESPONSE_SHAPE.NORMAL;
}
